export class NxiConfigUtil {
    static getCommunityName(appSettings: any) {
        let configMap: any = this.getIbdConfigMap(appSettings);
        let community = configMap && configMap.community ? configMap.community : 'netxinvestor';
        return community;
    }
    static getIbdConfigMap(appSettings: any) {
        let parsemap = {};
        if (appSettings && appSettings.ibdConfigMap) {
            parsemap = appSettings.ibdConfigMap;
        }
        return parsemap;
    }
}
